"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
var _handleUserId = _interopRequireDefault(require("./services/handleUserId"));
var _handleSessionId = _interopRequireDefault(require("./services/handleSessionId"));
var _ids = require("./ids");
var _handleAffiliateId = _interopRequireDefault(require("./services/handleAffiliateId"));
var _handleDeeplinkId = _interopRequireDefault(require("./services/handleDeeplinkId"));
var _handleUTMs = _interopRequireDefault(require("./services/handleUTMs"));
const init = () => {
  const {
    userId,
    user_id,
    // deprecated format, force 'userId'
    affilId,
    affilid,
    // deprecated format, force 'affilId'
    deeplinkId,
    ...rest
  } = _queryString.default.parse(window.location.search);
  return {
    userId: (0, _handleUserId.default)((userId || user_id) && String(userId || user_id)),
    sessionId: (0, _handleSessionId.default)(),
    pageViewId: (0, _ids.makePageViewId)(),
    deeplinkId: (0, _handleDeeplinkId.default)(deeplinkId && String(deeplinkId)),
    affiliate: (0, _handleAffiliateId.default)((affilId || affilid) && String(affilId || affilid), rest),
    UTMs: (0, _handleUTMs.default)(rest)
  };
};
var _default = init;
exports.default = _default;